// src/services/visitService.js
import axios from 'axios';
import { API_BASE_URL } from './apiConfig';

const BASE_URL = API_BASE_URL;

// Function to add a visit
export const addVisit = async (visitData) => {
    const token = localStorage.getItem('token');
    try {
        const response = await axios.post(`${BASE_URL}/addVisit.php`, visitData, {
            headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        });
        return { success: true, data: response.data };
    } catch (error) {
        console.error('Error adding visit:', error);
        return { success: false, message: error.message };
    }
};

export const updateVisit = async (visitData) => {
    const token = localStorage.getItem('token');
    try {
        const response = await axios.post(`${BASE_URL}/updateVisit.php`, visitData, {
            headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        });
        return { success: true, data: response.data };
    } catch (error) {
        console.error('Error updating visit:', error);
        return { success: false, message: error.message };
    }
};

// Function to delete a visit
export const deleteVisit = async (visitId) => {
    const token = localStorage.getItem('token');
    try {
        const response = await axios.post(`${BASE_URL}/deleteVisit.php`, { id: visitId }, {
            headers: { Authorization: `Bearer ${token}` },
        });
        return { success: true, data: response.data };
    } catch (error) {
        console.error('Error deleting visit:', error);
        return { success: false, message: error.message };
    }
};

export const getRecentVisits = async (page = 1, perPage = 10) => {
    const token = localStorage.getItem('token');
    try {
        const response = await axios.get(`${BASE_URL}/getRecentVisits.php`, {
            params: { page, per_page: perPage },
            headers: { Authorization: `Bearer ${token}` }
        });
        return { success: true, ...response.data };
    } catch (error) {
        console.error('Error fetching recent visits:', error);
        return { success: false, error: error.message };
    }
};
